// src/admin/AdminLogin.jsx
import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { apiRequest, setAuthToken } from "../services/apiClient";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  // Agar unauthorized redirect aya to message dikhao
  const unauthorized = searchParams.get("error") === "unauthorized";

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const result = await apiRequest("/auth/login", {
        method: "POST",
        body: JSON.stringify({ email, password }),
      });
      setAuthToken(result.token);
      navigate("/admin");
    } catch (error) {
      setError(error.message === "Failed to fetch"
        ? "Cannot connect to the MySQL API. Start it with: npm run api"
        : error.message || "Invalid email or password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: "100vh", background: "#0f1117",
      display: "flex", alignItems: "center", justifyContent: "center",
      fontFamily: "var(--font-main)"
    }}>
      <div style={{
        background: "#161b27", border: "1px solid rgba(255,255,255,0.08)",
        borderRadius: 14, padding: 40, width: "100%", maxWidth: 400
      }}>
        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <div style={{ fontFamily: "var(--font-display)", fontSize: 28, fontWeight: 800, color: "var(--cyan)", letterSpacing: 1 }}>
            CIRCUIT
          </div>
          <div style={{ fontSize: 11, color: "rgba(255,255,255,0.35)", letterSpacing: 2, textTransform: "uppercase" }}>
            Admin Panel
          </div>
        </div>

        {/* Unauthorized warning */}
        {unauthorized && (
          <div style={{
            background: "rgba(233,30,140,0.1)", border: "1px solid rgba(233,30,140,0.3)",
            borderRadius: 8, padding: "12px 16px", marginBottom: 20,
            color: "#E91E8C", fontSize: 13, textAlign: "center"
          }}>
            🚫 Access denied. You are not an authorized admin.
          </div>
        )}

        <form onSubmit={handleLogin} style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>
            <label style={{ fontSize: 12, fontWeight: 700, color: "rgba(255,255,255,0.4)", textTransform: "uppercase", letterSpacing: 1 }}>
              Email
            </label>
            <input
              type="email" value={email} onChange={e => setEmail(e.target.value)}
              placeholder="admin@circuitprinting.ca" required
              style={{ background: "rgba(255,255,255,0.05)", border: "1px solid rgba(255,255,255,0.1)", borderRadius: 6, padding: "11px 14px", color: "white", fontFamily: "var(--font-main)", fontSize: 14, outline: "none" }}
            />
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>
            <label style={{ fontSize: 12, fontWeight: 700, color: "rgba(255,255,255,0.4)", textTransform: "uppercase", letterSpacing: 1 }}>
              Password
            </label>
            <input
              type="password" value={password} onChange={e => setPassword(e.target.value)}
              placeholder="••••••••" required
              style={{ background: "rgba(255,255,255,0.05)", border: "1px solid rgba(255,255,255,0.1)", borderRadius: 6, padding: "11px 14px", color: "white", fontFamily: "var(--font-main)", fontSize: 14, outline: "none" }}
            />
          </div>
          {error && (
            <p style={{ color: "var(--magenta)", fontSize: 13, fontWeight: 600, textAlign: "center" }}>{error}</p>
          )}
          <button type="submit" disabled={loading}
            style={{ background: "var(--cyan)", color: "white", border: "none", borderRadius: 6, padding: "12px", fontFamily: "var(--font-main)", fontWeight: 700, fontSize: 15, cursor: loading ? "not-allowed" : "pointer", opacity: loading ? 0.7 : 1, marginTop: 4 }}>
            {loading ? "Signing In..." : "Sign In →"}
          </button>
        </form>
      </div>
    </div>
  );
}
